import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  getPromotionDiscription () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/PromotionDiscriptions/list',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updatePromotion (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Promotion/request',
        payload,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.updateFail)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  addPromotionProduct (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'PromotionProduct/create',
        payload,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  deletePromotionProduct (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.del(
        'PromotionProduct/delete',
        payload,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  addPromotionProducts (payload) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'PromotionProduct/bulk_create',
        payload,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/promotionservice.js